import { apiClient } from './api'

export type Invitation = {
  id: string
  email: string
  organization_id: string
  organization_name?: string
  role_id: string
  role_name?: string
  status: 'pending' | 'accepted' | 'expired' | 'cancelled'
  invited_by: string
  inviter_name?: string
  expires_at: string
  created_at: string
}

export type InvitationPublicInfo = {
  organization_name: string
  organization_type?: string
  role_name: string
  inviter_name: string
  email: string
  status: string
  is_expired: boolean
  user_exists: boolean
}

export type InvitationAcceptRequest = {
  full_name?: string
  password?: string
}

export const invitationApi = {
  create: (data: {
    email: string
    role_id: string
    organization_id?: string
  }): Promise<Invitation> => apiClient.post('/api/v1/invitations', data),

  list: (params?: { all_orgs?: boolean; organization_id?: string }): Promise<Invitation[]> => {
    const queryParams = new URLSearchParams()
    if (params?.all_orgs) queryParams.append('all_orgs', 'true')
    if (params?.organization_id) queryParams.append('organization_id', params.organization_id)
    const query = queryParams.toString()
    return apiClient.get(`/api/v1/invitations${query ? `?${query}` : ''}`)
  },

  cancel: (invitationId: string, allOrgs = false): Promise<void> =>
    apiClient.delete(`/api/v1/invitations/${invitationId}${allOrgs ? '?all_orgs=true' : ''}`),

  // Token e prazo novos; o e-mail sai antes de gravar (502 = nada mudou; #1122)
  resend: (invitationId: string, allOrgs = false): Promise<Invitation> =>
    apiClient.post(
      `/api/v1/invitations/${invitationId}/resend${allOrgs ? '?all_orgs=true' : ''}`,
      {},
    ),

  getInfo: (token: string): Promise<InvitationPublicInfo> =>
    apiClient.get(`/api/v1/invitations/accept/${token}`),

  accept: (
    token: string,
    data?: InvitationAcceptRequest,
  ): Promise<{ message: string; organization_id?: string; user_id?: string }> =>
    apiClient.post(`/api/v1/invitations/accept/${token}`, data || {}),
}
